module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nv",
    class: _vm.theme,
    attrs: {
      "id": "nv"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('spinner') : [_c('search'), _vm._v(" "), _c('editor'), _vm._v(" "), _c('foot')]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4526ede!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/NV.vue
// module id = 2189
// module chunks = 0